module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_dress@3x-096ec0f657f254eec98ffa305e081200.webp";